/** Stable identifiers for merchant-configuration failures that block a send. */
export const MarketingSendConfigErrorCode = {
  MissingSenderNumber: "missing_sender_number",
  SenderNumberNotReady: "sender_number_not_ready",
  ConversationNotFound: "conversation_not_found",
  ConversationChannelMismatch: "conversation_channel_mismatch",
} as const;

export type MarketingSendConfigErrorCode =
  (typeof MarketingSendConfigErrorCode)[keyof typeof MarketingSendConfigErrorCode];

/**
 * A send blocked by the team's own configuration. Every retry fails identically
 * until someone changes the setup, so callers must not treat it as transient.
 */
export class MarketingSendConfigError extends Error {
  constructor(
    readonly code: MarketingSendConfigErrorCode,
    message: string,
  ) {
    super(message);
    this.name = "MarketingSendConfigError";
  }
}
